export default "<!-- <div class=\"container container-wrapper\"></div> -->\n<router-outlet></router-outlet>\n"